import { useMutation } from 'react-query'
import axios from 'axios'
import { useSession } from '../components/Organisms/Authentication Dialog/SessionProvider'
import { auth_config } from '../features/API/auth_config'

const useQuestionnaireMutation = (options) => {
  const { jwt } = useSession()

  return useMutation((questionnaire) => {
    return axios.patch(
      `${auth_config.base}/api/v1/questionnaire/${questionnaire.key}`,
      { questionnaire },
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    )
  }, options)
}

export default useQuestionnaireMutation
